/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerDto } from '../../models/customer-dto';

export interface ApiCustomerAllGet$Plain$Params {
}

export function apiCustomerAllGet$Plain(http: HttpClient, rootUrl: string, params?: ApiCustomerAllGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerDto>>> {
  const rb = new RequestBuilder(rootUrl, apiCustomerAllGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CustomerDto>>;
    })
  );
}

apiCustomerAllGet$Plain.PATH = '/api/Customer/all';
